module.exports = __webpack_public_path__ + "static/media/1.de8a591a.jpg";